module.exports = __webpack_public_path__ + "img/content-1.176aa87d.png";